<template>
	<v-container fluid pa-0 dark flat>
		<v-layout row wrap class="inner-container" justify-center my-0 align-center
		 	:style="{height: (windowHeight - headerHeight - footHeight) + 'px'}"
			:class="{'mx-0': $vuetify.breakpoint.smAndDown, 'mx-5': $vuetify.breakpoint.mdAndUp}">
			<v-flex xs12 md6 px-5 justify-center>
				<h2 class="text-duo mb-3">Lo sentimos, esta página no se encuentra disponible.</h2>
				<h3 class="text-duo">Si necesitas nuestros servicios llámanos al +569  6590 9598 o escríbenos a info@duoapp.cl</h3>
			</v-flex>
			<v-flex xs12 md6 px-5 justify-center>
				<img :src='require("../../assets/static/img/404.png")' alt="imagen pagina no encontrada">
			</v-flex>
		</v-layout>
	</v-container>
</template>
<script>
  import { EventBus } from '../../events.js'
  export default {
  	name: '404',
    data() {
    	return {
    		windowHeight:0,
    		headerHeight:0,
    		footHeight:0
    	}
    },
	  methods: {
      getWindowHeight(event) {
        this.windowHeight = document.documentElement.clientHeight
      }
	  },
	  mounted() {
	    this.$nextTick(function() {
	      this.getWindowHeight()
	    })
			EventBus.$on('headHeight', data => {
				this.headerHeight = document.getElementById('fullheader').clientHeight
				console.log("Head: ", this.headerHeight)
			})
			EventBus.$on('footHeight', data => {
				this.footHeight = data
				console.log("Foot: ", this.footHeight)
			})
	  }
  }
</script>